// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"406":"f3ecb2f0","443":"a6de56b7"}[chunkId] + ".css";
};